function pad(num) {
    return ("0"+num).slice(-2);
}
export function mmss(secs) {
    var minutes = Math.floor(secs / 60);
    secs = secs%60;
    minutes = minutes%60;
    return `${pad(minutes)}:${pad(secs)}`;
    // return pad(hours)+":"+pad(minutes)+":"+pad(secs); for old browsers
}